
import { useFaqsLoader } from "./faqs/useFaqsLoader";
import { useFaqActions } from "./faqs/useFaqActions";
import { useEffect, useRef } from "react";

export const useAdminFaqs = () => {
  const { 
    faqs, 
    loading: loadingFaqs, 
    loadFaqs, 
    setFaqs,
    isLoaded 
  } = useFaqsLoader();

  const {
    createFaq,
    updateFaq,
    deleteFaq,
    isProcessing
  } = useFaqActions(loadFaqs);

  const initialLoadDoneRef = useRef(false);

  // Load FAQs on component mount but only once
  useEffect(() => {
    if (!initialLoadDoneRef.current && !isLoaded) {
      console.log("Initial FAQs loading in useAdminFaqs");
      loadFaqs();
      initialLoadDoneRef.current = true;
    }
  }, [loadFaqs, isLoaded]);

  return {
    faqs,
    loading: loadingFaqs || isProcessing,
    loadFaqs,
    createFaq,
    updateFaq,
    deleteFaq
  };
};
